<template>
    <SetBudgetDialog
        :value="value"
        @input="$emit('input', $event)"
        :budget="budget"
        :loading="$wait.is('creatingBudget')"
    >
        <template #activator="bindings">
            <slot v-bind="bindings"></slot>
        </template>
        <template #default="{ form, formId, isValid, loading, close }">
            <CreateBudgetButton
                :value="form"
                :clear="() => {}"
                :valid="isValid"
                :form="formId"
                :loading="loading"
                v-wait-while="'creatingBudget'"
                @http2xx="close().then(() => handleSuccessfulCreation($event))"
            >
            </CreateBudgetButton>
        </template>
    </SetBudgetDialog>
</template>

<i18n>
{
    "en": {
        "createBudgetDialog.events.successfulCreation": "Successfully created the budget '{name}'"
    }
}
</i18n>

<script>
import SetBudgetDialog from '@/components/Domain.Budgets/SetBudgetDialog.vue';
import CreateBudgetButton from '@/components/Domain.Budgets/CreateButtonButton.vue';
import { toastSuccess } from '@/components/Common/Toast.vue';
export default {
    components: { SetBudgetDialog, CreateBudgetButton },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        budget: {
            type: Object,
            default: null,
        },
    },
    methods: {
        handleSuccessfulCreation(form) {
            toastSuccess(this.$t('createBudgetDialog.events.successfulCreation', { name: form.name }));
            this.$emit('http2xx', form);
            this.$router.push('/budgets');
        },
    },
};
</script>